/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
export const tangerine = {
    50: '#FFEAD6',
    100: '#FFD2A8',
    200: '#FFAF66',
    300: '#FFA047',
    400: '#FF8A1F',
    500: '#FF7A00',
    600: '#E96A02',
    700: '#CB5D03',
    800: '#954300',
    900: '#753500',
    1000: '#4D2300',
};
